import styled, { css, keyframes } from 'styled-components';
import { OVERLAY_WIDTH } from './types';

const fadeIn = keyframes`
  0% {opacity: 0}
  100% {opacity: 1}
`;

export const DatePicker = styled.div<{
  isVisible: boolean;
  isMobile: boolean;
  left: number;
  top: number;
  width?: number;
  overAll?: boolean;
}>`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  grid-template-columns: 1fr;
  justify-content: center;
  left: ${({ left }) => (Number.isNaN(left) ? 0 : left)}px;
  margin-top: 3px;
  min-width: ${OVERLAY_WIDTH}px;
  position: ${({ isMobile }) => (isMobile ? 'initial' : 'absolute')};
  top: ${({ top }) => (Number.isNaN(top) ? 0 : top)}px;
  user-select: none;
  width: ${({ isMobile, width }) => (isMobile ? 'initial' : `${width}px`)};
  z-index: ${({ theme, isMobile, overAll }) =>
    isMobile || overAll ? theme.layers.intermediateTopLayer : theme.layers.intermediateBaseLayer};

  ${({ isVisible }) =>
    isVisible
      ? css`
          display: flex;
          opacity: 1;
        `
      : css`
          display: none;
          opacity: 0;
        `}
`;

export const PickerContainer = styled.div<{ isMobile: boolean }>`
  background-color: ${({ theme }) => theme.white};
  border-radius: 8px;
  box-shadow: 0px 1px 12px rgba(45, 45, 45, 0.25);
  display: grid;
  min-width: ${OVERLAY_WIDTH}px;
  box-sizing: border-box;
  padding: 16px;
  width: ${({ isMobile }) => (isMobile ? 'inherit' : 'initial')};
`;

export const DateHeader = styled.div`
  align-items: center;
  display: flex;
  font-family: 'Mulish', sans-serif;
  width: ${OVERLAY_WIDTH - 32}px;
  height: 32px;
  justify-content: space-between;
  padding: 0 4px;
  margin: auto;
  text-transform: capitalize;
  span {
    color: ${({ theme }) => theme.gray4D};
    font-size: 16px;
  }
`;

export const IconContainer = styled.div`
  align-items: center;
  cursor: pointer;
  display: flex;
  height: 24px;
  justify-content: center;
  width: 24px;
`;

export const Days = styled.div`
  align-items: center;
  display: grid;
  width: ${OVERLAY_WIDTH - 32}px;
  font-family: 'Mulish', sans-serif;
  grid-template-columns: repeat(7, 1fr);
  grid-template-rows: 1fr;
  height: 36px;
  margin-top: 8px;
  text-align: center;
  text-transform: capitalize;
  margin: auto;
  span {
    color: ${({ theme }) => theme.gray4D};
    font-size: 14px;
    font-weight: 700;
  }
`;

export const Dates = styled.div`
  cursor: pointer;
  display: grid;
  width: ${OVERLAY_WIDTH - 32}px;
  font-family: 'Mulish', sans-serif;
  grid-template-columns: repeat(7, 1fr);
  grid-template-rows: repeat(5, 1fr);
  row-gap: 4px;
  text-align: center;
  margin: auto;
  span {
    align-items: center;
    display: flex;
    justify-content: center;
  }
`;

export const EmptyCell = styled.span`
  cursor: auto;
`;

export const Overlay = styled.div<{ isVisible: boolean; overAll: boolean }>`
  align-items: center;
  background-color: ${({ theme }) => theme.overlayBlack};
  display: none;
  flex-direction: column;
  height: 100vh;
  justify-content: center;
  left: 0;
  position: fixed;
  top: 0;
  transition: all 1s ease-in-out;
  width: 100vw;
  z-index: ${({ theme, overAll }) =>
    overAll ? theme.layers.intermediateTopLayer : theme.layers.intermediateBaseLayer};

  ${({ isVisible }) =>
    isVisible &&
    css`
      animation: ${fadeIn} 0.3s;
      display: flex;
    `}
`;

export const MobileLabelContainer = styled.div`
  align-items: center;
  background-color: ${({ theme }) => theme.white};
  border-radius: 8px;
  box-shadow: 0px 1px 12px rgba(45, 45, 45, 0.25);
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  padding: 16px;
  width: inherit;
`;

export const MobileLabel = styled.div`
  font-size: 18px;
  font-weight: 700;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const MobileLabelClose = styled.div`
  border-radius: 50%;
  margin: -5px;
  padding: 5px;
  transition: all 0.2s ease-in-out;

  :hover {
    background: ${({ theme }) => theme.grayF0};
  }

  :active {
    background: ${({ theme }) => theme.grayCC};
  }
`;
